var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSailing({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(0 3)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#83B3F9",
    fillRule: "nonzero",
    d: "m22.294 0 0 32.945c-.536-2.83-.982-5.5-1.337-8.01l.002-24.935 1.335 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M22.967 34.135c2.965-8.743 4.512-17.5 1.373-31.802 10.893 6.02 19.26 14.673 22.06 29.124-9.777-2.167-17.588-1.274-23.433 2.678Zm-19.916 2.382c3.467-5.728 8.423-14.37 14.868-25.929-.146 6.124.714 14.003 2.581 23.637-6.513-1.028-12.33-.264-17.45 2.292Zm6.332-35.09c3.068-1.768 6.301-.147 9.418-.927l0 4.096c-2.535 1.2-4.57-1.814-7.177 0l-2.241-3.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#83B3F9",
    d: "m0 39.6 50-5.975c0 5.975-5.959 9.743-10.072 9.743l-37.452 0-2.476-3.768Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M40.18 34.798c2.182-.26 5.456-.652 9.82-1.173 0 5.975-5.959 9.743-10.072 9.743 2.435-3.122 2.52-5.979.252-8.57Z",
    opacity: 0.304
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSailing);
export default __webpack_public_path__ + "static/media/sailing.9b49cd918b3f569a0cab87a3562c3ee9.svg";
export { ForwardRef as ReactComponent };